import 'css-chunksrc/client/pages/zonesPage/projectsPage/toolbar/styles.scss';export default {
  "toolbar": "_toolbar_578ky_1",
  "section": "_section_578ky_6",
  "title": "_title_578ky_12",
  "sort": "_sort_578ky_18",
  "filter": "_filter_578ky_22"
};